import { useCallback as e, useRef as t } from "react";
//#region src/components/FullscreenGallery/hooks/useGallerySwipe.ts
var n = 50, r = (r) => {
	let i = t(0), a = t(0);
	return {
		onTouchStart: e((e) => {
			i.current = e.touches[0].clientX, a.current = e.touches[0].clientY;
		}, []),
		onTouchEnd: e((e) => {
			let t = e.changedTouches[0].clientX - i.current, o = e.changedTouches[0].clientY - a.current;
			Math.abs(t) < n || Math.abs(o) > Math.abs(t) || (t < 0 ? r.goNext() : r.goPrev());
		}, [r])
	};
};
//#endregion
export { r as useGallerySwipe };
